module.exports = __webpack_public_path__ + "img/university.1a07e835.svg";